<script>
import config from '@/common/genericPanelConf';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import Service from '@/services/stock-management'
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

export default {
    components: {
        ResponsiveButton
    },
    data(){
        return{
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1)
            },
            twentyFour: '24.00',
            data: [],
            showLegend: false
        }
    },
    created(){    
        this.$store.dispatch('security/setNavbarTitle', 'DischargeDropsReport.page_title');     
    },
    watch:{
        /*'filters.referenceDate'(){
            this.load();
        } */   
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    mounted(){
        this.loadFromCache();
    },
    methods: {
        load(){
            let body = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
            }

            this.saveCache(); 
            
            this.$store.dispatch("generic/setLoading", true);
            Service.getDischargeDropsReport(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.data = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        exportExcel(){
            let body = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
            }

            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = "ReportCaliDiscarica.xlsx";
            Service.getDischargeDropsReportExcel(body, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
        
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        onClickShowLegend(){
            this.showLegend = !this.showLegend;
        },
        saveCache(){
            let cacheData = {
                name: 'DischargeDropsGrid',
                filters: { referenceDate: this.filters.referenceDate }
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
        },
        loadFromCache(){
            let cacheData = this.$store.getters['cacheDataStore/getGridCache']('DischargeDropsGrid');
            if(cacheData){
                this.filters = { referenceDate: cacheData.referenceDate }
            }

            this.load(true);
        },
    }
}
</script>

<template>
    <main>
        <div class="grid" style="margin-left: 0.2%">
            <div class="col-4 lg:col-2">
                <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.referenceDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-2 lg:col-1">
                <label>{{$t('at')}}</label>
                <InputText readOnly v-model="twentyFour" class="w-full" />
            </div>      
            <div class="col-12 lg:col-4 mt-2">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-2 my-3 p-button-sm" @click="load"/> 
                <ResponsiveButton style="color: green;" :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-2 my-3 p-button-sm p-button-outlined" @click="exportExcel"/> 
            </div>
        </div>

       <div class="col-12 data" style="margin-top: 2vh;">
            <div class="grid">
                <div class="col-12">
                    <DataTable stripedRows :value="data" scrollable :responsiveLayout="'stack'" scrollHeight="flex" sortMode="single" :sortOrder="1" dataKey="id">

                        <Column style="min-width: 130px;" field="referenceDate" :header="$t('DischargeDropsReport.referenceDate')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatDate(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;" field="tankCode" :header="$t('DischargeDropsReport.tankCode')" />

                        <Column class="initial" field="lockedDate" :header="$t('DischargeDropsReport.lockedDate')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}} </span>
                            </template>
                        </Column>

                        <Column class="final" field="endOperationDate" :header="$t('DischargeDropsReport.endOperationDate')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}} </span>
                            </template>
                        </Column>                      

                        <Column class="final" field="fiscalStockWeight" :header="$t('DischargeDropsReport.fiscalStockWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="final" field="fiscalStockVolume" :header="$t('DischargeDropsReport.fiscalStockVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="dailyStock" field="cofiLockedWeight" :header="$t('DischargeDropsReport.cofiLockedWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="dailyStock" field="cofiLockedVolume" :header="$t('DischargeDropsReport.cofiLockedVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="dailyStock" field="sludgeWeight" :header="$t('DischargeDropsReport.sludgeWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="dailyStock" field="sludgeVolume" :header="$t('DischargeDropsReport.sludgeVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="final" style="min-width: 150px;" field="fiscalMovedWeight" :header="$t('DischargeDropsReport.fiscalMovedWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="final" style="min-width: 150px;" field="fiscalMovedVolume" :header="$t('DischargeDropsReport.fiscalMovedVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="total" field="theoreticalWeight" :header="$t('DischargeDropsReport.theoreticalWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="total" field="theoreticalVolume" :header="$t('DischargeDropsReport.theoreticalVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="total" field="deltaWeight" :header="$t('DischargeDropsReport.deltaWeight')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                        <Column class="total" field="deltaVolume" :header="$t('DischargeDropsReport.deltaVolume')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatInteger(data[field]) : null}} </span>
                            </template>
                        </Column>

                    </DataTable>
                </div>
            </div>
         </div>
    </main>  
</template>

<style>
    .initial{
        min-width: 130px;
        background-color: none;
    }

    .final{
        min-width: 150px;
        background-color: none;
    }

    .dailyStock{
        min-width: 130px;
        background-color: none;
    }

    .total{
        min-width: 150px;
    }
</style>
